<template>
  <div>
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header image="logo.png" @toggleSidebar="toggleSidebar" />

    <div class="contact-container">
      <div class="container">
        <div class="contact-wrapper" v-loading="loading">
          <!-- 文章内容 -->
          <div v-if="articleData" class="article-content">
            <div class="article-body" v-html="articleData"></div>
          </div>
          
          <!-- 加载中 -->
          <div v-else-if="loading" class="loading-placeholder">
            <el-skeleton :rows="10" animated />
          </div>
          
          <!-- 空状态 -->
          <el-empty v-else description="暂无内容" />
        </div>
      </div>
    </div>

    <footer-one />
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Drawer from "@/components/Mobile/Drawer.vue";
import FooterOne from "@/components/Utility/Footer/FooterOne.vue";
import Header from "@/components/Utility/Header/index";
import { getArticleRichText } from "@/api/article";
import config from "@/config";

export default {
  name: "Traffic",
  components: { Header, FooterOne, Drawer },
  data() {
    return {
      sidebar: false,
      loading: true,
      articleData: null,
    };
  },
  created() {
    document.addEventListener("scroll", this.topToBottom);
    this.fetchArticle();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.topToBottom);
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result?.classList.add("active");
      } else {
        result?.classList.remove("active");
      }
    },
    /**
     * 获取文章详情
     * 这里使用固定的文章 ID，你可以根据需要修改
     */
    async fetchArticle() {
      // 🔥 替换为你需要的文章 ID
      const ARTICLE_ID = config.CONTACTID; // 这里改成你需要的文章ID
      
      this.loading = true;
      try {
        const response = await getArticleRichText(ARTICLE_ID);
        if (response.code < 300 && response.data) {
          this.articleData = response.data.body;
        } else {
          this.$message.error(response.msg || '获取文章失败');
        }
      } catch (error) {
        console.error('获取文章失败:', error);
        this.$message.error('获取文章失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    /**
     * 格式化日期
     */
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
  },
};
</script>

<style scoped>
.contact-container {
  padding: 40px 0 60px;
  min-height: 60vh;
  background: #f8fafc;
}

.contact-wrapper {
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 50px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.article-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a3a6b;
  margin-bottom: 16px;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid #f0f2f5;
  color: #999;
  font-size: 14px;
}

.article-body {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.article-body :deep(p) {
  margin-bottom: 16px;
}

.article-body :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 16px 0;
}

.article-body :deep(h2),
.article-body :deep(h3) {
  margin: 24px 0 12px;
  color: #1a3a6b;
}

.article-body :deep(ul),
.article-body :deep(ol) {
  padding-left: 24px;
  margin-bottom: 16px;
}

.article-body :deep(blockquote) {
  border-left: 4px solid #2978dd;
  padding-left: 16px;
  margin: 16px 0;
  color: #666;
  background: #f5f8fe;
  padding: 12px 20px;
  border-radius: 4px;
}

.loading-placeholder {
  padding: 20px 0;
}

@media (max-width: 768px) {
  .traffic-container {
    padding: 20px 16px;
  }

  .traffic-wrapper {
    padding: 24px 20px;
  }

  .article-title {
    font-size: 22px;
  }

  .article-body {
    font-size: 15px;
  }

  .article-meta {
    flex-wrap: wrap;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .traffic-wrapper {
    padding: 16px;
  }

  .article-title {
    font-size: 19px;
  }

  .article-body {
    font-size: 14px;
  }
}
</style>